"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _reactPdf = _interopRequireDefault(require("@mikecousins/react-pdf"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-require-imports
var DownloadIcon = require('@tencent/ixd-icons-react/dist').DownloadIcon;

function index(props) {
  var _a;

  var src = props.src,
      title = props.title,
      style = props.style,
      extendProps = props.extendProps,
      loadText = props.loadText;

  var _b = (0, _react.useState)(1),
      page = _b[0],
      setPage = _b[1]; // pdf当前页数
  // const [loading, setLoading] = useState(true); // 是否加载中


  var _c = (0, _react.useState)(1.2),
      scale = _c[0],
      setScale = _c[1]; // pdf当前缩放倍数


  var _d = (0, _react.useState)(0),
      pageTotal = _d[0],
      setPageTotal = _d[1]; // pdf总页数


  var pdfRef = (0, _react.useRef)();
  var handleSrc = decodeURIComponent(src);
  var fileName = (_a = handleSrc === null || handleSrc === void 0 ? void 0 : handleSrc.split('/')) === null || _a === void 0 ? void 0 : _a.pop(); // 由url获取文件名

  var onDocumentComplete = function onDocumentComplete(pages) {
    setPageTotal(pages); // setLoading(false);
  };

  var handleScale = function handleScale(isScale) {
    if (isScale) {
      var newScale = Math.round((scale + 0.1) * 10) / 10;
      setScale(newScale);
    } else {
      var newScale = Math.round((scale - 0.1) * 10) / 10;
      setScale(newScale);
    }
  };

  var handleScroll = function handleScroll(e) {
    var _a;

    var scrollTop = (_a = e.target) === null || _a === void 0 ? void 0 : _a.scrollTop;
    var pdfview = pdfRef === null || pdfRef === void 0 ? void 0 : pdfRef.current;
    var listNodes = pdfview === null || pdfview === void 0 ? void 0 : pdfview.childNodes;
    var hCanvas = listNodes[0].getBoundingClientRect().height;
    var heightCanvas = hCanvas + 24;
    var canvasLength = (listNodes === null || listNodes === void 0 ? void 0 : listNodes.length) - 1;
    var newPage = Math.floor(scrollTop / heightCanvas) + 2;

    if (newPage >= canvasLength && canvasLength !== 0) {
      setPage(canvasLength);
      return;
    }

    if (scrollTop === 0) {
      setPage(1);
    } else {
      setPage(newPage);
    }
  };

  (0, _react.useEffect)(function () {
    var pdfview = pdfRef === null || pdfRef === void 0 ? void 0 : pdfRef.current;
    pdfview === null || pdfview === void 0 ? void 0 : pdfview.addEventListener('scroll', handleScroll);
    return function () {
      pdfview === null || pdfview === void 0 ? void 0 : pdfview.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function fileLinkToStreamDownload(url, fileName, type) {
    // const reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;
    // if (!reg.test(url)) {
    //   throw new Error('传入参数不合法,不是标准的文件链接');
    // } else {
    var _a, _b; // }


    var name = '';
    var fileArr = fileName === null || fileName === void 0 ? void 0 : fileName.split('_');

    if ((fileArr === null || fileArr === void 0 ? void 0 : fileArr.length) === 2 && ((_a = fileArr[0]) === null || _a === void 0 ? void 0 : _a.length) === 7) {
      // eslint-disable-next-line prefer-destructuring
      name = fileArr[1];
    } else if ((fileArr === null || fileArr === void 0 ? void 0 : fileArr.length) > 2 && ((_b = fileArr[0]) === null || _b === void 0 ? void 0 : _b.length) === 7) {
      fileArr === null || fileArr === void 0 ? void 0 : fileArr.splice(0, 1);
      name = fileArr === null || fileArr === void 0 ? void 0 : fileArr.join('_');
    } else {
      name = fileName;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.setRequestHeader('Content-Type', "application/" + type);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      if (this.status === 200) {
        // 接受二进制文件流
        var blob = this.response;
        downloadExportFile(blob, name);
      }
    };

    xhr.send();
  }

  function downloadExportFile(blob, tagFileName) {
    var downloadElement = document.createElement('a');
    var href = blob;

    if (typeof blob === 'string') {
      downloadElement.target = '_blank';
    } else {
      href = window.URL.createObjectURL(blob); // 创建下载的链接
    }

    downloadElement.href = href;
    downloadElement.download = "" + tagFileName; // 下载后文名

    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载

    document.body.removeChild(downloadElement); // 下载完成移除元素

    if (typeof blob !== 'string') {
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-wrap',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-main'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-title'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-content-wrap'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-content',
    ref: pdfRef
  }, /*#__PURE__*/_react["default"].createElement(_reactPdf["default"], {
    file: src || 'https://qcloudimg.tencent-cloud.cn/raw/00237d8ac6094bb11847e3d8d248fabf.pdf',
    onDocumentComplete: onDocumentComplete,
    page: 1,
    scale: scale
  }), pageTotal ? new Array(pageTotal).fill('').map(function (item, index) {
    return index + 1 !== 1 ? /*#__PURE__*/_react["default"].createElement(_reactPdf["default"], {
      file: src || 'https://qcloudimg.tencent-cloud.cn/raw/00237d8ac6094bb11847e3d8d248fabf.pdf',
      page: index + 1,
      scale: scale,
      key: item + index
    }) : '';
  }) : null), pageTotal ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pdf-view-pagetotal"
  }, /*#__PURE__*/_react["default"].createElement("p", null, page, " / ", pageTotal)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pdf-view-scale"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pdf-view-scale-content"
  }, /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: "pdf-view-scale-tag",
    onClick: function onClick() {
      return handleScale(false);
    }
  }, extendProps || {})), /*#__PURE__*/_react["default"].createElement("span", null, Math.round(scale * 100), "%"), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: "pdf-view-scale-tag add",
    onClick: function onClick() {
      return handleScale(true);
    }
  }, extendProps || {})))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pdf-view-load",
    onClick: function onClick() {
      return fileLinkToStreamDownload(src || 'https://qcloudimg.tencent-cloud.cn/raw/00237d8ac6094bb11847e3d8d248fabf.pdf', fileName, 'pdf');
    }
  }, /*#__PURE__*/_react["default"].createElement(DownloadIcon, {
    className: 'd-icon'
  }), /*#__PURE__*/_react["default"].createElement("span", null, loadText ? loadText : 'Download'))) : null)));
}